export default (function (page) {
    if (window.analytics) {
        window.analytics.page(page);
    }
    return page;
});
//# sourceMappingURL=useAnalytics.js.map